<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box full-width-reading">

                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <ul>
                                        <li><a href="#/covid">COVID - 19 Protocols</a></li>
                                        <li><a href="#/visaprocess">Visa Process</a></li>
                                        <li><a href="#/appterms">Visa Application Terms</a></li>
                                        <li><a href="#/needvisa">Do I Need a Visa</a></li>
                                        <li><a href="#/req_photo">Photo Requirements</a></li>
                                        <li><a class="active" href="#/req_passport">Passport Requirements</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-1" />

                        <div class="col-8">
                            <div class="document top98">

                                <h2>Passport Requirements</h2>
                                <img class="img-fluid img-thumbnail top32" src="/images/passport.png" />
                                <p class="top32">Please upload an image, in color, of your passport information page that contains photo and personal details in PDF format. The size of the photo must be less or equal to 1 megabyte (MB)</p>
                                <p>Use a scanner or camera for taking a photo of the passport (not a copy of it).</p>
                                <p>Before uploading, please review the taken image and make sure that the following information is clearly readable:</p>
                                <ul>
                                    <li>Passport Number</li>
                                    <li>Names</li>
                                    <li>Nationality</li>
                                    <li>Date of Birth</li>
                                    <li>Date of Issuance and Expiration</li>
                                </ul>
                                <p>If your passport image is not clearly readable it will be rejected at verification stage and you will be required to send another image thus delaying your application Process.</p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <ul>
                            <li><a href="#/covid">COVID - 19 Protocols</a></li>
                            <li><a href="#/visaprocess">Visa Process</a></li>
                            <li><a href="#/appterms">Visa Application Terms</a></li>
                            <li><a href="#/needvisa">Do I Need a Visa</a></li>
                            <li><a href="#/req_photo">Photo Requirements</a></li>
                            <li><a class="active" href="#/req_passport">Passport Requirements</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top16">
                    <div class="document">

                        <h2>Passport Requirements</h2>
                        <img class="img-fluid img-thumbnail top32" src="/images/passport.png" />
                        <p class="top32">Please upload an image, in color, of your passport information page that contains photo and personal details in PDF format. The size of the photo must be less or equal to 1 megabyte (MB)</p>
                        <p>Use a scanner or camera for taking a photo of the passport (not a copy of it).</p>
                        <p>Before uploading, please review the taken image and make sure that the following information is clearly readable:</p>
                        <ul>
                            <li>Passport Number</li>
                            <li>Names</li>
                            <li>Nationality</li>
                            <li>Date of Birth</li>
                            <li>Date of Issuance and Expiration</li>
                        </ul>
                        <p>If your passport image is not clearly readable it will be rejected at verification stage and you will be required to send another image thus delaying your application Process.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'ReqPassport',

        model: {},
        data: () => ({

        }),
        mounted() {
            this.goToTop();

        },
        computed: {

        },
        methods: {
            goToTop: function () {
                $("html, body").animate({ scrollTop: 0 }, "fast");
            },
        }
    }
</script>

<style scoped>
</style>